const STORAGE_KEY = 'trembo:climate:telemetry';
const MAX_EVENTS = 240;

function safeRead() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function safeWrite(items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.isArray(items) ? items.slice(0, MAX_EVENTS) : []));
  } catch {}
}

export function appendClimateTelemetry(event) {
  if (typeof window === 'undefined') return;
  const payload = event && typeof event === 'object' ? event : {};
  const next = [
    {
      id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
      ts: new Date().toISOString(),
      type: String(payload.type || 'event'),
      farmId: String(payload.farmId || ''),
      view: String(payload.view || ''),
      status: String(payload.status || ''),
      message: String(payload.message || ''),
      sourceLabel: String(payload.sourceLabel || ''),
      durationMs: Number.isFinite(Number(payload.durationMs)) ? Number(payload.durationMs) : null,
      details: payload.details && typeof payload.details === 'object' ? payload.details : null,
    },
    ...safeRead(),
  ].slice(0, MAX_EVENTS);
  safeWrite(next);
}

export function readClimateTelemetry({ farmId = '', hours = 168 } = {}) {
  const cutoff = Date.now() - Math.max(1, Number(hours) || 168) * 60 * 60 * 1000;
  return safeRead().filter((item) => {
    const ts = Date.parse(item?.ts || '');
    if (!Number.isFinite(ts) || ts < cutoff) return false;
    if (farmId && String(item?.farmId || '') !== String(farmId)) return false;
    return true;
  });
}

export function summarizeClimateTelemetry(items = []) {
  const source = Array.isArray(items) ? items : [];
  const counts = source.reduce((acc, item) => {
    const type = String(item?.type || 'event');
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {});
  const refreshDurations = source
    .filter((item) => String(item?.type || '').startsWith('load_'))
    .map((item) => Number(item?.durationMs))
    .filter((value) => Number.isFinite(value) && value >= 0);
  const avgRefreshMs = refreshDurations.length ? Math.round(refreshDurations.reduce((sum, value) => sum + value, 0) / refreshDurations.length) : null;
  const lastError = source.find((item) => String(item?.status || '') === 'error') || null;
  const lastSuccess = source.find((item) => String(item?.status || '') === 'success') || null;
  return {
    total: source.length,
    counts,
    avgRefreshMs,
    lastError,
    lastSuccess,
    latest: source[0] || null,
  };
}
